module.exports = __webpack_public_path__ + "img/jumeirah-res.83294e8e.png";